import { mutator } from 'satcheljs';
import { resetLegacyStore } from '../actions/legacyStoreActions';
import { getComposeStore } from '../selectors/getComposeStore';

mutator(resetLegacyStore, actionMessage => {
    const store = getComposeStore(null /* formId */);
    store.formId = null;
    store.openedForm = null;
    store.originalEvent = null;
    store.event = null;
    store.uiState = null;
    store.metricsInfo = null;
    store.attachmentFiles = null;
});
